import { ForwardedRef, useImperativeHandle, useRef } from 'react';

export const useForwardRef = <T>(ref: ForwardedRef<T>, initialValue: T | null = null) => {
  const targetRef = useRef<T | null>(initialValue);

  useImperativeHandle<T | null, T | null>(ref, () => targetRef.current, []);

  return targetRef;
};
